// 单独展示一张图片的页面

<template>
  <img style="width: 100%; display: block;" :src="src" alt="" />
</template>

<script>

export default {
  computed: {
    src () {
      return decodeURIComponent(this.$route.query.src)
    }
  }
}

</script>
